import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'
import { parseRmaProductDTOList, RmaProductDTO } from 'components/ordering/rma/api/dtos/rma-product-dto.js'
import { StatusCodeToError } from 'components/ordering/rma/api/dtos/error.js'

const EXPECTED_ERRORS = [401] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

export class SearchRmaProducts extends RmaRequest<RmaProductDTO[], ExpectedErrors> {
  path: string
  override expectedErrors = EXPECTED_ERRORS

  constructor({ searchTerm }: { searchTerm: string }) {
    super()
    const params = new URLSearchParams({ searchTerm })
    this.path = `account/rma/search/product/?${params}`
  }

  override parseResponse = (data: unknown) =>
    parseRmaProductDTOList((data as { results: unknown }).results)
}
